import { render, staticRenderFns } from "./tenantChangePasswordModal.vue?vue&type=template&id=60f15039&"
import script from "./tenantChangePasswordModal.vue?vue&type=script&lang=js&"
export * from "./tenantChangePasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports